var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pl-4 pr-2"},[_c('span',{staticClass:"text-subtitle-1"},[_vm._v("Antall tidsserier: "+_vm._s(this.timeSeriesCount)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }